/**
 * Awaits createDynamicEvent to avoid loading delays on the frontend
 * On Intuit domain, automatically uses AppFabric's analytics.track via window.appFabricInstance
 * @param {string} dynamicConfig - URL to the dynamic event configuration
 * @param {string} dynamicId - Unique identifier for the dynamic event
 * @param {object} defaultProperties - Default properties for the event
 * @param {object} additionalProperties - Additional properties to merge
 * @returns void
 */
export const dispatchDynamicEventById = async (
  dynamicConfig,
  dynamicId,
  defaultProperties,
  additionalProperties,
) => {
  const { createDynamicEventById } = await import('./createDynamicEvent');
  await createDynamicEventById(
    dynamicConfig,
    dynamicId,
    defaultProperties,
    additionalProperties,
  );
};
